import { useDispatch, useSelector } from 'react-redux';
import useGlobalLoader from '../app/useGlobalLoader';
import useRest from '../useRest';
import { saveMenuData } from '../../redux/actions/menu';
import { getMenuData as getMenuDataSelector } from '../../redux/selectors/menu';

const useMenu = (manual = false, showErrorMessage = true) => {
    const data = useSelector(getMenuDataSelector);
    const dispatch = useDispatch();
    const gl = useGlobalLoader();
    const rest = useRest(showErrorMessage);

    const getMenuData = async () => {
        if (!manual) {
            gl.toggleLoader({
                loading: true,
                title: 'Загрузка меню',
            });
        }

        const result = await rest.fetch({
            method: 'get',
            objectName: '/user/menu',
        });

        if (!result.isError && result.response?.data) {
            dispatch(saveMenuData(result.response?.data));
        }

        if (!manual) {
            gl.toggleLoader({
                loading: false,
                title: 'Загрузка меню',
            });
        }

        return result;
    };

    return {
        data,
        getMenuData,
    };
};

export default useMenu;
